import { IContentSource } from "../../../domain/drawing";
import { AbstractSource } from "../../drawing";

export class ReferenceFileSource extends AbstractSource implements IContentSource {
  constructor(
    getToken: () => string,
    public fileId: number,
  ) {
    super(getToken);
  }

  protected getSource(): string {
    return "/api/format/referencefile/" + this.fileId + "?token=" + this.token;
  }

  public clone(): IContentSource {
    return new ReferenceFileSource(
      this._getToken,
      this.fileId
    );
  }
}
